module.exports = __webpack_public_path__ + "img/service_quick_as.ff235bf5.png";